import { render, staticRenderFns } from "./DictionariesSync.vue?vue&type=template&id=97050152&"
import script from "./DictionariesSync.vue?vue&type=script&lang=js&"
export * from "./DictionariesSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports